import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { getSquishVIN } from 'site-modules/shared/utils/vin-utils';
import { FormErrorMessage } from 'site-modules/shared/components/vin-decoder/form-error-message/form-error-message';

import './vin-input-form.scss';

export const VinInputForm = ({ onVinSubmit }) => {
  const [vin, setVin] = useState('');
  const [error, setError] = useState('');

  const handleVinChange = useCallback(
    e => {
      let formattedVin = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');

      if (formattedVin.length > 17) {
        formattedVin = formattedVin.substring(0, 17);
      }

      setVin(formattedVin);
      if (error) setError('');
    },
    [error]
  );

  const handleSubmit = useCallback(
    e => {
      e.preventDefault();
      setError('');

      if (vin.length !== 17) {
        setError('The VIN must be exactly 17 characters long.');
        return;
      }

      const squishVin = getSquishVIN(vin);

      if (!squishVin) {
        setError('Invalid VIN entered. Please check and try again.');
        return;
      }
      onVinSubmit({ vin, squishVin });
    },
    [vin, onVinSubmit]
  );

  return (
    <div className="vin-input-form-wrapper">
      <form onSubmit={handleSubmit} noValidate className="vin-input-form-container">
        <div className="vin-input-form">
          <input
            type="text"
            id="vin"
            name="vin"
            value={vin}
            onChange={handleVinChange}
            maxLength={17}
            placeholder="Enter VIN"
            className="vin-input-field"
            aria-invalid={!!error}
            aria-describedby="vin-error"
          />
          <button type="submit" className="vin-submit-button">
            Submit VIN
          </button>
        </div>
        {error && (
          <div id="vin-error" className="vin-error-section" role="alert">
            <FormErrorMessage id="Not 17 Chars" message={error} />
          </div>
        )}
      </form>
    </div>
  );
};

VinInputForm.propTypes = {
  onVinSubmit: PropTypes.func.isRequired,
};
